import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledNutritionalInfo,
  NutritionTable,
  NutritionTableBody,
  NutritionTableRow,
  NutritionTableData,
} from './styles';

export const NutritionalInfo = ({ nutritionalInfo }) => (
  <StyledNutritionalInfo>
    <NutritionTable>
      <NutritionTableBody>
        {nutritionalInfo.map(item => (
          <NutritionTableRow key={`${item.label}-${item.value}`}>
            <NutritionTableData>{item.label}</NutritionTableData>
            <NutritionTableData>{item.value}</NutritionTableData>
          </NutritionTableRow>
        ))}
      </NutritionTableBody>
    </NutritionTable>
  </StyledNutritionalInfo>
);

NutritionalInfo.displayName = 'NutritionInfo';
NutritionalInfo.propTypes = {
  nutritionalInfo: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
